import Conversation from "../model/Conversation";

export default class ConversationStartedEvent {
    /**
     * @constructor
     * @param {Conversation} conversation 
     */
    constructor(conversation) {
        this._type = ConversationStartedEvent.TYPE;

        this._conversation = conversation;
    }

    get type() {
        return this._type;
    }
}

ConversationStartedEvent.TYPE = "ConversationStartedEvent";